import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
`;

export const RadioWrapper = styled.div`
  width: ${rem(170)};
`;
